module.exports = new __parcel__URL__("arrow-down-circle.70916082.svg").toString();